<template>
  <div class="slogan">
    <div class="left">
      <p class="oneword" v-html="oneword" />
      <p class="keywords" v-html="keywords" />
      <div class="buttons">
        <template v-for="(button, index) in buttons">
          <a :key="index" :href="button.href" v-if="button.href">
            <el-button v-bind="button" size="medium">{{ button.label }}</el-button>
          </a>
          <el-button :key="index" v-bind="button" @click="onClick(button.prop)" size="medium" v-else>{{ button.label }}</el-button>
        </template>
      </div>
    </div>
    <div class="right">
      <img class="topic" :src="topic" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'slogan',
  data() {
    return {
      buttons: [
        { prop: 'start', type: 'primary', label: this.$t('Home.slogan.button.start.label'), href: '#starter' },
        { prop: 'contact', type: 'primary', plain: true, label: this.$t('Home.slogan.button.contact.label'), href: '#footer' }
      ]
    }
  },
  computed: {
    topic: function() {
      return require('@/assets/box.png')
    },
    oneword: function() {
      return this.$t('Home.slogan.static.oneword.label')
    },
    keywords: function() {
      return this.$t('Home.slogan.static.keywords.label')
    }
  },
  methods: {
    onClick(command) {
      switch (command) {
        default:
          // console.log('unsupport command: ', command)
          break
      }
    }
  }
}
</script>

<style scoped>
.slogan {
  width: 100%;
  height: 60rem;

  display: flex;
  flex-direction: row;
}

.slogan .left {
  width: 50%;
  height: 100%;
  padding: 10rem 0 0 10rem;

  display: flex;
  flex-direction: column;
}
.slogan .right {
  width: 50%;
  height: 100%;
}

.left .oneword {
  font-size: 3.75rem;
  line-height: 4.5rem;
  padding-bottom: 1rem;
  color: #161616;
}
.left .keywords {
  font-size: 1.8rem;
  line-height: 3rem;
  color: #595959;
}
.left .buttons {
  padding-top: 2rem;

  display: flex;
  flex-direction: row;
}

.right .topic {
  width: 60rem;
  height: 60rem;
}

.buttons a {
  padding-right: 1rem;
}
</style>
